import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ items }) {
  return (
    <nav
      className="print:hidden flex items-center flex-wrap gap-2 font-mono text-[10px] uppercase tracking-wide-2 text-ink-500"
      data-testid="breadcrumb"
    >
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={idx}>
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="hover:text-ink-900 transition-colors"
                data-testid={`breadcrumb-${idx}`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={isLast ? "text-ink-900 normal-case tracking-normal font-sans text-xs font-medium" : ""}
                data-testid={`breadcrumb-${idx}`}
              >
                {item.label}
              </span>
            )}
            {!isLast && <span className="text-ink-300">/</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
